import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Base from "../../Config/Base";
import { API_BASE_CRM_URL } from "../../Config/Config";
import { Link } from "react-router-dom";
import { useLabelContext } from "../../../Context";
import { useLocation } from "react-router-dom";
import { Input, Button, message, Tabs } from "antd";
import { Footer } from "../footer/footer";
import Note from "./Note";
import Contacts from "./Contacts";
import Reminders from "../DynamicReminders/Reminders";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
export default function ViewCustomer() {
  const navigate = useNavigate();
  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (!userDetails) {
      navigate("/");
    }
  }, [navigate]);
  const location = useLocation();
  const customerId = location.state?.customerId;
  const [customersData, setCustomerData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(
    location.state?.activeTab || "profile",
  );
  const [formData, setFormData] = useState({
    company: "",
    phonenumber: "",
    city: "",
    zip: "",
    state: "",
    address: "",
    website: "",

    billing_street: "",
    billing_city: "",
    billing_state: "",
    billing_zip: "",

    shipping_street: "",
    shipping_city: "",
    shipping_state: "",
    shipping_zip: "",
  });
  const fetchData = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        `${API_BASE_CRM_URL}customers/GetCustomerDetails?CusId=${customerId}`,
      );

      const data = await response.json();

      if (data.Status) {
        setCustomerData(data.ResultData[0]);
        setFormData(data.ResultData[0]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [customerId]);

  const handleUpdateCustomer = async () => {
    try {
      setUpdateLoading(true);

      const payload = {
        userid: customersData.userid,
        company: formData.company,
        phonenumber: formData.phonenumber,
        city: formData.city,
        zip: formData.zip,
        state: formData.state,
        address: formData.address,
        website: formData.website,

        billing_street: formData.billing_street,
        billing_city: formData.billing_city,
        billing_state: formData.billing_state,
        billing_zip: formData.billing_zip,

        shipping_street: formData.shipping_street,
        shipping_city: formData.shipping_city,
        shipping_state: formData.shipping_state,
        shipping_zip: formData.shipping_zip,

        addedfrom: 1,
      };

      const response = await fetch(
        `${API_BASE_CRM_URL}customers/UpdateCustomer`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();
      if (data.Status) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: data.message,
          timer: 2000,
          showConfirmButton: false,
        });

        setIsEditing(false);

        await fetchData();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.message,
        });
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error,
      });
    } finally {
      setUpdateLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const items = [
    {
      key: "profile",
      label: (
        <span className="custom-tab-label">
          <i className="fas fa-user me-1"></i>
          <span>Profile</span>
        </span>
      ),
      children: (
        <>
          {isEditing ? (
            <>
              <div className="container-fluid p-2">
                <div className="card shadow-sm border-0">
                  <div className="card-body">
                    <div className="row g-3">
                      <div className="col-md-6">
                        <Input
                          name="company"
                          value={formData.company}
                          onChange={handleChange}
                          size="large"
                          placeholder="Organization Name"
                          prefix={<i className="fas fa-building"></i>}
                        />
                      </div>

                      <div className="col-5">
                        <Input
                          name="phonenumber"
                          value={formData.phonenumber}
                          onChange={handleChange}
                          size="large"
                          placeholder="Phone Number"
                          prefix={<i className="fas fa-phone"></i>}
                        />
                      </div>

                      <div className="col-7">
                        <Input
                          name="website"
                          value={formData.website}
                          onChange={handleChange}
                          size="large"
                          placeholder="Website URL"
                          prefix={<i className="fas fa-globe"></i>}
                        />
                      </div>

                      <div className="col-6">
                        <Input
                          name="city"
                          value={formData.city}
                          onChange={handleChange}
                          size="large"
                          placeholder="City"
                          prefix={<i className="fas fa-city"></i>}
                        />
                      </div>

                      <div className="col-6">
                        <Input
                          name="state"
                          value={formData.state}
                          onChange={handleChange}
                          size="large"
                          placeholder="State"
                          prefix={<i className="fas fa-map"></i>}
                        />
                      </div>

                      <div className="col-6">
                        <Input
                          name="zip"
                          value={formData.zip}
                          onChange={handleChange}
                          size="large"
                          placeholder="Zip Code"
                          prefix={<i className="fas fa-mail-bulk"></i>}
                        />
                      </div>

                      <div className="col-12">
                        <Input.TextArea
                          rows={3}
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                          size="large"
                          placeholder="Address"
                        />
                      </div>
                    </div>

                    <h6 className="mt-4 mb-3">
                      <i className="fas fa-file-invoice-dollar me-2"></i>
                      Billing Address
                    </h6>

                    <Input.Group>
                      <div className="row g-3">
                        <div className="col-6">
                          <Input
                            name="billing_street"
                            value={formData.billing_street}
                            onChange={handleChange}
                            size="large"
                            placeholder="Billing Street"
                            prefix={<i className="fas fa-road"></i>}
                          />
                        </div>

                        <div className="col-6">
                          <Input
                            name="billing_city"
                            value={formData.billing_city}
                            onChange={handleChange}
                            size="large"
                            placeholder="Billing City"
                            prefix={<i className="fas fa-city"></i>}
                          />
                        </div>

                        <div className="col-6">
                          <Input
                            name="billing_state"
                            value={formData.billing_state}
                            onChange={handleChange}
                            size="large"
                            placeholder="Billing State"
                            prefix={<i className="fas fa-map"></i>}
                          />
                        </div>

                        <div className="col-6">
                          <Input
                            name="billing_zip"
                            value={formData.billing_zip}
                            onChange={handleChange}
                            size="large"
                            placeholder="Billing Zip Code"
                            prefix={<i className="fas fa-mail-bulk"></i>}
                          />
                        </div>
                      </div>
                    </Input.Group>

                    <h6 className="mt-4 mb-3">
                      <i className="fas fa-truck me-2"></i>
                      Shipping Address
                    </h6>

                    <div className="row g-3">
                      <div className="col-6">
                        <Input
                          name="shipping_street"
                          value={formData.shipping_street}
                          onChange={handleChange}
                          size="large"
                          placeholder="Shipping Street"
                          prefix={<i className="fas fa-road"></i>}
                        />
                      </div>

                      <div className="col-6">
                        <Input
                          name="shipping_city"
                          value={formData.shipping_city}
                          onChange={handleChange}
                          size="large"
                          placeholder="Shipping City"
                          prefix={<i className="fas fa-city"></i>}
                        />
                      </div>

                      <div className="col-6">
                        <Input
                          name="shipping_state"
                          value={formData.shipping_state}
                          onChange={handleChange}
                          size="large"
                          placeholder="Shipping State"
                          prefix={<i className="fas fa-map"></i>}
                        />
                      </div>

                      <div className="col-6">
                        <Input
                          name="shipping_zip"
                          value={formData.shipping_zip}
                          onChange={handleChange}
                          size="large"
                          placeholder="Shipping Zip Code"
                          prefix={<i className="fas fa-mail-bulk"></i>}
                        />
                      </div>
                    </div>

                    <div className="d-flex justify-content-end gap-2 mt-4">
                      <Button
                        onClick={() => {
                          setIsEditing(false);
                          setFormData(customersData);
                        }}
                      >
                        Cancel
                      </Button>

                      <Button
                        type="primary"
                        loading={updateLoading}
                        onClick={handleUpdateCustomer}
                      >
                        Update Customer
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="container-fluid p-2">
              <div className="card shadow-sm border-0">
                <div className="card-body">
                  {/* Customer Information */}
                  <div className="mb-3">
                    <div className="d-flex justify-content-between border-bottom pb-1">
                      <h6>
                        <i className="fas fa-building me-2 text-primary"></i>
                        Customer Information
                      </h6>

                      <i
                        className="fa-solid fa-edit"
                        onClick={() => setIsEditing(true)}
                        style={{ cursor: "pointer" }}
                      ></i>
                    </div>

                    <div className="row g-2">
                      <div className="col-12">
                        <i className="fas fa-building text-muted me-2"></i>
                        <b>{customersData?.company || "N/A"}</b>
                      </div>

                      <div className="col-5">
                        <i className="fas fa-phone text-muted me-2"></i>
                        <small>{customersData?.phonenumber || "N/A"}</small>
                      </div>

                      <div className="col-7">
                        <i className="fas fa-globe text-muted me-2"></i>
                        {customersData?.website ? (
                          <a
                            href={customersData.website}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="small text-break"
                          >
                            {customersData.website}
                          </a>
                        ) : (
                          <small>N/A</small>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Address Information */}
                  <div className="mb-3">
                    <h6 className="border-bottom pb-1">
                      <i className="fas fa-map-marker-alt me-2 text-success"></i>
                      Address Information
                    </h6>

                    <div className="row g-2">
                      <div className="col-6">
                        <i className="fas fa-city text-muted me-2"></i>
                        <small>{customersData?.city || "N/A"}</small>
                      </div>

                      <div className="col-6">
                        <i className="fas fa-map text-muted me-2"></i>
                        <small>{customersData?.state || "N/A"}</small>
                      </div>

                      <div className="col-6">
                        <i className="fas fa-mail-bulk text-muted me-2"></i>
                        <small>{customersData?.zip || "N/A"}</small>
                      </div>

                      <div className="col-12">
                        <i className="fas fa-home text-muted me-2"></i>
                        <small>{customersData?.address || "N/A"}</small>
                      </div>
                    </div>
                  </div>

                  {/* Billing Address */}
                  <div className="mb-3">
                    <h6 className="border-bottom pb-1">
                      <i className="fas fa-file-invoice-dollar me-2 text-warning"></i>
                      Billing Address
                    </h6>

                    <div className="row g-2">
                      <div className="col-12">
                        <i className="fas fa-road text-muted me-2"></i>
                        <small>{customersData?.billing_street || "N/A"}</small>
                      </div>

                      <div className="col-6">
                        <i className="fas fa-city text-muted me-2"></i>
                        <small>{customersData?.billing_city || "N/A"}</small>
                      </div>

                      <div className="col-6">
                        <i className="fas fa-map text-muted me-2"></i>
                        <small>{customersData?.billing_state || "N/A"}</small>
                      </div>

                      <div className="col-6">
                        <i className="fas fa-mail-bulk text-muted me-2"></i>
                        <small>{customersData?.billing_zip || "N/A"}</small>
                      </div>
                    </div>
                  </div>

                  {/* Shipping Address */}
                  <div>
                    <h6 className="border-bottom pb-1">
                      <i className="fas fa-truck me-2 text-info"></i>
                      Shipping Address
                    </h6>

                    <div className="row g-2">
                      <div className="col-12">
                        <i className="fas fa-road text-muted me-2"></i>
                        <small>{customersData?.shipping_street || "N/A"}</small>
                      </div>

                      <div className="col-6">
                        <i className="fas fa-city text-muted me-2"></i>
                        <small>{customersData?.shipping_city || "N/A"}</small>
                      </div>

                      <div className="col-6">
                        <i className="fas fa-map text-muted me-2"></i>
                        <small>{customersData?.shipping_state || "N/A"}</small>
                      </div>

                      <div className="col-6">
                        <i className="fas fa-mail-bulk text-muted me-2"></i>
                        <small>{customersData?.shipping_zip || "N/A"}</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      ),
    },
    {
      key: "contacts",
      label: (
        <span className="custom-tab-label">
          <i className="fas fa-file-alt me-1"></i>
          <span>Contacts</span>
        </span>
      ),
      children: <Contacts customerId={customerId} />,
    },

    {
      key: "reminders",
      label: (
        <span className="custom-tab-label">
          <i className="fas fa-bell me-1"></i>
          <span>Follow-Ups</span>
        </span>
      ),
      children: <Reminders customerId={customerId} relType="Customer" />,
    },
    {
      key: "notes",
      label: (
        <span className="custom-tab-label">
          <i className="fas fa-sticky-note me-1"></i>
          <span>Notes</span>
        </span>
      ),
      children: <Note id={customersData?.id} type="leads" />,
    },
  ];

  return (
    <Base>
      <div className="page-heade mb-3">
        <div className="row align-items-center justify-content-between">
          <div className="col-10">
            <div className="page-title">
              <h4>
                Customer Details-
                {customersData?.company
                  ? customersData.company.length > 15
                    ? `${customersData.company.substring(0, 15)}...`
                    : customersData.company
                  : "N/A"}
              </h4>
              <p className="fw-semibold">View details</p>
            </div>
          </div>
          <div className="col-2 d-flex justify-content-end">
            <Link to="/customers">
              <button className="btn btn-secondary btn-sm">
                <i className="fa-solid fa-list"></i>
              </button>
            </Link>
          </div>
          <style>
            {`
              /* Default tab color */
              .custom-tabs .ant-tabs-tab {
                color: #666;
              }
  
              /* Active tab text color */
              .custom-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
                color: #FF8D1F !important;
              }
  
              /* Active tab icon color */
              .custom-tabs .ant-tabs-tab.ant-tabs-tab-active svg {
                color: #FF8D1F !important;
              }
  
              /* Underline color */
              .custom-tabs .ant-tabs-ink-bar {
                background: #FF8D1F !important;
              }
  
              /* Optional hover effect */
              .custom-tabs .ant-tabs-tab:hover,
              .custom-tabs .ant-tabs-tab:hover svg {
                color: #FF8D1F;
              }`}
          </style>
          <div className="my-2">
            <Tabs
              activeKey={activeTab}
              onChange={(key) => setActiveTab(key)}
              animated
              size="small"
              items={items}
              className="custom-tabs"
            />
          </div>
        </div>
      </div>

      <Footer />
    </Base>
  );
}
